import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Pabrik.css"; // Menggunakan file CSS yang sama
import Swal from "sweetalert2";
import axios from "axios";

const PabrikH = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [hasilData, setHasilData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [tanggal, setTanggal] = useState("");
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Ambil informasi user
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchHasilProduksi();
  }, []);

  const fetchHasilProduksi = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/lihat_hasil_produksi_pabrik",
        { withCredentials: true }
      );

      if (response.status === 200) {
        const sortedData = response.data.sort((a, b) => b.id - a.id);
        setHasilData(sortedData);
      } else {
        Swal.fire("Error", response.data.error, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Terjadi kesalahan saat mengambil data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Apakah Anda yakin?",
      text: "Data yang dihapus tidak dapat dikembalikan!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Batal",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setHasilData(hasilData.filter((item) => item.id !== id));
        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
      }
    });
  };

  const handleDetail = (id) => {
    navigate(`/pabrikhld/detail/${id}`);
  };

  const handleAddData = () => {
    Swal.fire({
      title: "Tambah Data Produksi",
      html: `
        <div class="swal-form text-start mt-2">
          <div class="mb-2"><input id="hasil_cpo" class="form-control rounded-3" placeholder="Hasil CPO (kg)" type="number"></div>
          <div class="mb-2"><input id="tandan_kosong" class="form-control rounded-3" placeholder="Tandan Kosong (kg)" type="number"></div>
          <div class="mb-2"><input id="cangkang" class="form-control rounded-3" placeholder="Cangkang (kg)" type="number"></div>
          <div class="mb-2"><input id="sabut" class="form-control rounded-3" placeholder="Sabut (kg)" type="number"></div>
          <div class="mb-2"><input id="bungkil" class="form-control rounded-3" placeholder="Bungkil (kg)" type="number"></div>
          <div class="mb-0"><input id="pome" class="form-control rounded-3" placeholder="POME (kg)" type="number"></div>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Simpan Data",
      cancelButtonText: "Batal",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
      preConfirm: () => {
        const hasil_cpo = parseFloat(document.getElementById("hasil_cpo").value);
        const tandan_kosong = parseFloat(document.getElementById("tandan_kosong").value);
        const cangkang = parseFloat(document.getElementById("cangkang").value);
        const sabut = parseFloat(document.getElementById("sabut").value);
        const bungkil = parseFloat(document.getElementById("bungkil").value);
        const pome = parseFloat(document.getElementById("pome").value);

        if (isNaN(hasil_cpo)) {
          Swal.showValidationMessage("Hasil CPO wajib diisi!");
          return false;
        }

        return {
          hasil_cpo,
          limbah_produksi: {
            tandan_kosong: isNaN(tandan_kosong) ? 0 : tandan_kosong,
            cangkang: isNaN(cangkang) ? 0 : cangkang,
            sabut: isNaN(sabut) ? 0 : sabut,
            bungkil: isNaN(bungkil) ? 0 : bungkil,
            pome: isNaN(pome) ? 0 : pome,
          },
        };
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            "https://c-greenproject.org:7500/update_produksi",
            result.value,
            { headers: { "Content-Type": "application/json" }, withCredentials: true }
          );

          if (response.status === 200) {
            Swal.fire("Berhasil!", response.data.message, "success");
            setHasilData([
              {
                id: hasilData.length > 0 ? hasilData[0].id + 1 : 1,
                hasil_cpo: result.value.hasil_cpo,
                limbah_produksi: result.value.limbah_produksi,
                sumber_produksi: response.data.sumber_produksi || [],
                waktu_produksi: response.data.waktu_produksi || new Date().toISOString(),
              },
              ...hasilData,
            ]);
          } else {
            Swal.fire("Error", response.data.error, "error");
          }
        } catch (error) {
          Swal.fire("Error", "Terjadi kesalahan saat menyimpan data", "error");
        }
      }
    });
  };

  const totalPages = Math.ceil(hasilData.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = hasilData.slice(startIndex, startIndex + itemsPerPage);

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span id="user-role" style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/pabrikt")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrikt" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrikt" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Planting" /> Transaksi
            </div>
            <div
              onClick={() => navigate("/pabrikh")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/pabrikh")
                  ? "active text-white"
                  : ""
              }`}
              style={{
                color: location.pathname.includes("/pabrikh") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/packaging.png" alt="Harvest" /> Hasil
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Hasil Pabrik</h2>
              <p className="text-muted small mb-0">Kelola dan pantau hasil produksi CPO serta limbah pabrik.</p>
            </div>
            <button
              className="btn btn-success rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleAddData}
            >
              <i className="fa fa-plus me-2"></i>Tambah Data Produksi
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Card */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <h4 className="fw-bold text-success mb-3">Daftar Hasil Produksi</h4>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data hasil produksi...</p>
              </div>
            ) : hasilData && hasilData.length > 0 ? (
              <>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                    <thead className="table-light text-nowrap">
                      <tr>
                        <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                        <th className="text-center py-3" style={{ width: "90px" }}>ID CPO</th>
                        <th className="text-end py-3" style={{ width: "140px" }}>Hasil CPO</th>
                        <th className="text-end py-3" style={{ width: "140px" }}>Total Limbah</th>
                        <th className="py-3" style={{ width: "250px" }}>Sumber Produksi</th>
                        <th className="text-center py-3" style={{ width: "160px" }}>Waktu Produksi</th>
                        <th className="text-center py-3" style={{ width: "100px" }}>Rincian</th>
                        <th className="text-center py-3" style={{ width: "100px", borderTopRightRadius: "10px" }}>Hapus</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item, index) => (
                        <tr key={`hasil-${item.id || index}`}>
                          <td className="text-center fw-bold text-muted">
                            {startIndex + index + 1}
                          </td>
                          <td className="text-center font-monospace fw-bold text-secondary">
                            #{item.id}
                          </td>
                          <td className="text-end font-monospace text-success fw-bold">
                            {formatNumber(item.hasil_cpo)} kg
                          </td>
                          <td className="text-end font-monospace text-muted">
                            {typeof item.limbah_produksi === "object" && item.limbah_produksi !== null
                              ? formatNumber(Object.values(item.limbah_produksi).reduce((a, b) => a + Number(b), 0))
                              : formatNumber(item.limbah_produksi)} kg
                          </td>
                          <td>
                            {Array.isArray(item.sumber_produksi) && item.sumber_produksi.length > 0 ? (
                              <span className="text-dark">{item.sumber_produksi.join(", ")}</span>
                            ) : (
                              <span className="fst-italic text-muted">Tidak ada sumber</span>
                            )}
                          </td>
                          <td className="text-center text-muted small">
                            {item.waktu_produksi || "-"}
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-outline-info btn-sm rounded-pill px-3 fw-medium shadow-sm"
                              onClick={() => handleDetail(item.id)}
                            >
                              Detail
                            </button>
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-medium shadow-sm"
                              onClick={() => handleDelete(item.id)}
                            >
                              Hapus
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <nav className="mt-4">
                  <ul className="pagination justify-content-end mb-0">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link shadow-none rounded-start-pill"
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        Previous
                      </button>
                    </li>
                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        key={`page-${index + 1}`}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        <button
                          className="page-link shadow-none"
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? "disabled" : ""}`}>
                      <button
                        className="page-link shadow-none rounded-end-pill"
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-boxes mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Data Hasil Produksi</h5>
                <p className="mb-0">Silakan tambahkan data produksi pabrik baru Anda.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PabrikH;